import PropTypes from "prop-types";
import React, { Component } from "react";

import { MODAL_TYPES } from "../constants/modals";
import Header from "./Header";
import Menu from "./Menu";
import Button from "./shared/Button";
import RootModal from "../containers/RootModal";
import UserForm from "../containers/UserForm";
import ResponsiveFallback from "./shared/ResponsiveFallback";

const BODY_OVERFLOW_CLASSNAME = "overflow-hidden";
const MODEL_EXPORT_REGEXP = /^\/(en|es)?\/models\/export/;

class Layout extends Component {
  state = {
    shouldDisplayResponsiveFallback: false
  };

  constructor(props) {
    super(props);

    this.handleBarsIconClick = this.handleBarsIconClick.bind(this);
    this.handleOverlayClick = this.handleOverlayClick.bind(this);
    this.handleUserIconClick = this.handleUserIconClick.bind(this);
    this.handleResize = this.handleResize.bind(this);
  }

  componentDidMount() {
    this.handleResize();

    window.addEventListener("resize", this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  componentDidUpdate(prevProps, prevState) {
    // handle body overflow
    if (prevProps.bodyOverflow !== this.props.bodyOverflow) {
      if (this.props.bodyOverflow) {
        window.document.body.classList.add(BODY_OVERFLOW_CLASSNAME);
      } else {
        window.document.body.classList.remove(BODY_OVERFLOW_CLASSNAME);
      }
    }
  }

  handleBarsIconClick() {
    if (this.props.leftSidebarOpen) {
      this.props.closeUILeftSidebar();
    } else {
      this.props.openUILeftSidebar();
    }
  }

  handleUserIconClick() {
    if (!this.props.authLoaded) {
      return;
    }

    if (!this.props.authLoggedIn) {
      this.props.openModal({ modalType: MODAL_TYPES.SIGNIN });
    } else if (this.props.rightSidebarOpen) {
      this.props.closeUIRightSidebar();
    } else {
      this.props.openUIRightSidebar();
    }
  }

  handleOverlayClick() {
    this.props.leftSidebarOpen && this.props.closeUILeftSidebar();
    this.props.rightSidebarOpen && this.props.closeUIRightSidebar();
  }

  handleResize() {
    this.setState({
      shouldDisplayResponsiveFallback: window.innerWidth < 1024
    });
  }

  getStyles({ leftSidebarOpen, rightSidebarOpen }) {
    return {
      left: {
        transform: `translate3d(${leftSidebarOpen ? "0" : "-100%"}, 0, 0)`
      },
      right: {
        transform: `translate3d(${rightSidebarOpen ? "0" : "100%"}, 0, 0)`
      },
      overlay: {
        opacity: leftSidebarOpen || rightSidebarOpen ? 1 : 0
      },
      visibilityStyle: {
        visibility: leftSidebarOpen || rightSidebarOpen ? "visible" : "hidden"
      }
    };
  }

  render() {
    const isExport = MODEL_EXPORT_REGEXP.test(this.props.location.pathname);
    const shouldDisplayRightSidebar =
      this.props.authLoaded && this.props.authLoggedIn;

    // handle props based styles
    const styles = this.getStyles(this.props);

    // handle responsive fallback
    if (this.state.shouldDisplayResponsiveFallback) {
      return <ResponsiveFallback />;
    }

    // handle model export without layout markup
    if (isExport) {
      return this.props.children;
    }

    return (
      <div className="relative vh-100">
        <RootModal />

        {!this.props.headerHidden &&
          <Header
            lng={this.props.lng}
            t={this.props.t}
            authLoggedIn={this.props.authLoggedIn}
            leftSidebarOpen={this.props.leftSidebarOpen}
            rightSidebarOpen={this.props.rightSidebarOpen}
            handleBarsIconClick={this.handleBarsIconClick}
            handleUserIconClick={this.handleUserIconClick}
          />
        }

        {/* left sidebar */}
        <div className="sidebar-container" style={styles.visibilityStyle}>
          <div
            className="sidebar-overlay"
            style={styles.overlay}
            onClick={this.handleOverlayClick}
          />

          <div className="sidebar sidebar--left" style={styles.left}>
            <Menu
              t={this.props.t}
            />
          </div>

          {/* right sidebar */}
          {shouldDisplayRightSidebar && (
            <div className="sidebar sidebar--right" style={styles.right}>
              <div className="sidebar__title">{this.props.t("myaccount")}</div>

              <div className="sidebar__title">
                <Button label={this.props.t("account:disconnect")} onClick={this.props.signout} />
              </div>

              <div
                className="sidebar__content"
                style={{ maxHeight: window.innerHeight - 167 }}
              >
                <UserForm
                t={this.props.t}
                />
                <div className="mt3 tc">
                  <Button
                    label={this.props.t("account:deleteAccount")}
                    onClick={this.props.deleteUser}
                  />
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="cf vh-100">{this.props.children}</div>
      </div>
    );
  }
}

Layout.propTypes = {
  headerHidden: PropTypes.bool
};

export default Layout;



// WEBPACK FOOTER //
// ./src/components/Layout.js